var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26 5.83H1.69C0.76 5.83 0 6.59 0 7.52V13.2C0 14.13 0.76 14.89 1.69 14.89H6.26L7.13 15.54L14.04 20.72V0L7.13 5.18L6.26 5.83ZM19.32 11.46L17.26 13.52C17.11 13.67 16.91 13.75 16.7 13.75C16.49 13.75 16.3 13.67 16.14 13.52C15.83 13.21 15.83 12.72 16.14 12.41L18.2 10.35L16.14 8.29C15.83 7.98 15.83 7.49 16.14 7.18C16.45 6.87 16.94 6.87 17.25 7.18L19.31 9.24L21.37 7.18C21.68 6.87 22.17 6.87 22.48 7.18C22.79 7.49 22.79 7.98 22.48 8.29L20.42 10.35L22.48 12.41C22.79 12.72 22.79 13.21 22.48 13.52C22.33 13.67 22.13 13.75 21.92 13.75C21.71 13.75 21.52 13.67 21.36 13.52L19.3 11.46H19.32Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/Mute.07c1a581763db958b5e2e31c7143d76c.svg";
export { ForwardRef as ReactComponent };